import { render, staticRenderFns } from "./CeremonyNotReady.vue?vue&type=template&id=720b6577"
import script from "./CeremonyNotReady.vue?vue&type=script&lang=js"
export * from "./CeremonyNotReady.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports